import moment from 'moment';
import { formatDecimal } from '@/utilities/formatters';
import LightboxTemplateChart from '@/components/lightbox/LightboxTemplateChart';

const mixin = {
  data() {
    return {
      settings: this.$parent.settings,
    };
  },
  methods: {
    format({ labels, formatTo, formatFrom = 'YYYY-M' }) {
      let formatedLabels;

      if (formatTo === 'MMM/YY') {
        formatedLabels = labels.map(item => moment(item, formatFrom).format(formatTo).toUpperCase());
      }

      if (formatTo === 'tooltip') {
        return function formater() {
          let s = `<b>${this.x}</b>`;

          this.points.forEach(item => {
            let value = item.y;

            if (value < 0) value *= -1;

            s += `<br/><span style="color:${item.color}">\u25CF</span> ${item.series.name}: <strong>${formatDecimal(
              value,
              1,
            )}</strong>`;
          });
          return s;
        };
      }

      return formatedLabels || labels;
    },
  },
  components: {
    'lightbox-template-chart': LightboxTemplateChart,
  },
};

export default mixin;
